var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['haeder',_vm.color]},[_c('span',{staticClass:"left",on:{"click":_vm.aa}},[_vm._v("← "+_vm._s(_vm.title))]),_vm._v("|"),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }